import React, { useEffect, useRef } from 'react';

const ClickOutsideHandler = ({ children, onClickOutside }) => {

  const componentRef = useRef(null);

  useEffect(() => {
    
    const handleClickOutside = (event) => {
      if (componentRef.current && !componentRef.current.contains(event.target)) {
        onClickOutside();
      }
    };

    document.addEventListener('click', handleClickOutside);

    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, [onClickOutside]);

  return <div className="p-0" ref={componentRef}>{children}</div>;
};

export default ClickOutsideHandler;